import { AnalysisStoreProvider } from '@modules/analysis/store/AnalysisStoreProvider';
import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { FeedStoreProvider } from '@modules/feed/store/FeedStoreProvider';
import { QuantifyStoreProvider } from '@modules/quantify/store/QuantifyStoreProvider';
import { AnalysisUseCase } from 'generated/graphql';

interface DashboardAnalysisProviderProps {
  children: React.ReactNode;
  useCase: AnalysisUseCase;
}

export const DashboardAnalysisProvider = ({
  children,
  useCase,
}: DashboardAnalysisProviderProps) => {
  const defaultTimeRange = useGetDefaultTenantTimeRange();

  const renderProviders = () => {
    switch (useCase) {
      case AnalysisUseCase.Feed:
        return (
          <FeedStoreProvider defaultTimeRange={defaultTimeRange}>
            {children}
          </FeedStoreProvider>
        );
      default:
        return <QuantifyStoreProvider>{children}</QuantifyStoreProvider>;
    }
  };

  return (
    <AnalysisStoreProvider useCase={useCase}>
      {renderProviders()}
    </AnalysisStoreProvider>
  );
};
